import { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Avatar, IconButton, Modal, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import PictureViewer from "../../common/PictureViewer";
import { FETCH_CLIENT_CHANGE_TRACKER } from "../../constant/Apipath";
import { BIGrey, BILightGrey } from "../../assets/helpers";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

export const ClientChangeTrackerViewModel = ({ isOpen, onClose, data }) => {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const LANGUAGE = ClientEnglishFallback.ClientChangeTrackerViewModel(multiLanguageData?.ClientChangeTrackerViewModel || {});
  const { TEXT_JOB, TEXT_ME } = LANGUAGE;
  const [index, setIndex] = useState(null);
  const [pictureView, setPictureView] = useState(false); 
  const [isLoading, setIsLoading] = useState(false);
  const [trackerData, setTrackerData] = useState({});

  useEffect(() => {
    if (isOpen) {
      fetchChangeTrackerData();
    }
  }, [isOpen]);

  const fetchChangeTrackerData = async () => {
    setIsLoading(true);
    let jobObj = {
      PageNr: 1,
      NrOfRecPerPage: 1,
      FullSearch: "",
      UserId: loginData?.userInformation?.UserId,
      IncludeRecordNr: true,
      FetchAllowedRecordsOnly: true,
      SortList: [{ FieldName: "Date", Direction: "DESC" }],
      SearchList: [
        {
          id: data?.id,
        },
      ],
    };

    try {
      const jobRes = await Postrequestcall(
        FETCH_CLIENT_CHANGE_TRACKER,
        jobObj,
        loginData?.accessToken,
      );
      if (jobRes?.status === 200) {
        const trackerData = jobRes?.data?.data;
        setTrackerData(trackerData[0]);
      }
    } catch (error) {
      console.error("fetchChangeTrackerData-> Error fetching change tracker:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Modal open={isOpen} onClose={onClose}>
        <div className="client-modal-responsive">
          {isLoading ? (
            <Loader />
          ) : (
            <>
              <div className="action-button-container">
                <div></div>
                  <IconButton size="small" onClick={() => onClose()}
                  sx={{ color:selectedClientData?.AccentColor !==undefined &&selectedClientData?.AccentColor ? selectedClientData?.AccentColor : BILightGrey }}>
                  <CloseIcon />
                </IconButton>
              </div>
              <Stack display={"flex"} gap={1}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent={"space-between"}
                  spacing={2}
                >
                  <Stack>
                    <Typography
                      style={{
                        color: BIGrey,
                        fontSize: "1rem",
                      }}
                    >
                      {TEXT_JOB}
                    </Typography>
                    <Typography>{`${trackerData?.clientEmployeeJobCode} - ${trackerData?.clientEmployeeJobName}`}</Typography>
                  </Stack>
                </Stack>
                <Stack
                  direction="row"
                  width={"100%"}
                  alignItems="center"
                  justifyContent={"space-between"}
                  spacing={1}
                >
                  <Stack
                    marginBottom={1}
                    direction={"row"}
                    alignItems={"center"}
                    spacing={1}
                  >
                    <Avatar src={trackerData?.userProfilePicture} />
                    <Typography variant="body1">
                      {trackerData?.clientEmployeeName}{" "}
                      {selectedClientData?.ClientEmployeeId ===
                        trackerData?.clientEmployeeId && (
                        <span
                          style={{
                            color: BIGrey,
                            fontSize: "0.8rem",
                          }}
                        >
                          ({TEXT_ME})
                        </span>
                      )}
                    </Typography>
                  </Stack>

                  <Typography
                    style={{
                      color: BIGrey,
                    }}
                  >
                    {dayjs(trackerData?.date).format("MMMM DD, YYYY")}
                  </Typography>
                </Stack>
                <Stack maxHeight={200} overflow={"auto"}>
                  <Typography
                    style={{
                      wordBreak: "break-word",
                    }}
                  >{`${trackerData?.description}`}</Typography>
                </Stack>
                <Stack
                  style={{
                    scrollbarWidth: "none",
                  }}
                  display={"flex"}
                  direction={"row"}
                  gap={1}
                  overflow={"scroll"}
                >
                  {trackerData?.pictureList?.map((item, i) => (
                    <div key={i} style={{ cursor: "pointer" }}>
                      <img
                        loading="lazy"
                        onClick={() => {
                          setIndex(i);
                          setPictureView(true);
                        }}
                        src={item?.fileUrl}
                        alt="safety observation"
                        style={{
                          width: "100px",
                          height: "100px",
                          borderRadius: "5px",
                        }}
                      />
                    </div>
                  ))}
                </Stack>
              </Stack>
            </>
          )}
        </div>
      </Modal>
      <PictureViewer
        isOpen={pictureView}
        onClose={() => setPictureView(false)}
        pictures={trackerData?.pictureList?.map((item, i) => {
          return { src: item?.fileUrl };
        })}
        viewerIndex={index}
      />
    </>
  );
};
